import { render, staticRenderFns } from "./TradeTable.vue?vue&type=template&id=461f1710&"
import script from "./TradeTable.vue?vue&type=script&lang=js&"
export * from "./TradeTable.vue?vue&type=script&lang=js&"
import style0 from "./TradeTable.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports